'use client';

import Link from 'next/link';
import { ROUTES } from '../../lib/constants';

type Mode = 'login' | 'register';

export function AuthModeSwitch({ mode }: { mode: Mode }) {
  return (
    <p className="text-center text-sm text-gray-400 mt-6">
      {mode === 'login' ? (
        <>No account yet?{' '}
          <Link href={ROUTES.register} className="font-medium" style={{ color: 'var(--color-primary)' }}>
            Sign up for free.
          </Link>
        </>
      ) : (
        <>Already have an account?{' '}
          <Link href={ROUTES.login} className="font-medium" style={{ color: 'var(--color-primary)' }}>
            Sign in.
          </Link>
        </>
      )}
    </p>
  );
}
